import React from 'react';
import Microsurvey from './microsurvey-popup/microsurvey-popup';
import Header from './header/header';
import LowerStickyNote from './lower-sticky-note/lower-sticky-note';
import Footer from './footer/footer';
import { SalesforceContextProvider } from '~/contexts/salesforce';
import useMainClassContext, { MainClassContextProvider } from '~/contexts/main-class';
import useLanguageContext from '~/contexts/language';
import ReactModal from 'react-modal';
import TakeoverDialog from './takeover-dialog/takeover-dialog';
import cn from 'classnames';
import './default.scss';
export default function DefaultLayout({ children }) {
    // BrowserRouter has to include everything that uses useLocation
    return (React.createElement(React.Fragment, null,
        React.createElement(Microsurvey, null),
        React.createElement("header", { id: "header" },
            React.createElement(Header, null)),
        React.createElement("div", { id: "lower-sticky-note" },
            React.createElement(LowerStickyNote, null)),
        React.createElement(SalesforceContextProvider, null,
            React.createElement(MainClassContextProvider, null,
                React.createElement(Main, null, children))),
        React.createElement("footer", { id: "footer" },
            React.createElement(Footer, null))));
}
function Main({ children }) {
    const { language } = useLanguageContext();
    const ref = React.useRef(null);
    const { classes } = useMainClassContext();
    React.useEffect(() => {
        ReactModal.setAppElement(ref.current);
    }, []);
    return (React.createElement("div", { id: "main", className: cn('lang', 'layout-default', language, classes), ref: ref, tabIndex: -1 },
        React.createElement(TakeoverDialog, null),
        children));
}
